import { styled } from "@mui/material/styles";
import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { typographyStyles } from "./Typography";

export type ButtonVariant = "primary" | "white" | "outline" | "text";

interface CustomButtonProps extends Omit<MuiButtonProps, "variant"> {
  variant?: ButtonVariant;
}

const variantStyles = {
  primary: {
    background: "var(--brand-primary)",
    color: "var(--text-white)",
    border: "none",
    "&:hover": {
      background: "var(--brand-primary-hover)",
    },
  },
  white: {
    background: "var(--background-white)",
    color: "var(--text-primary)",
    border: "1px solid var(--button-border)",
    "&:hover": {
      background: "#e8e8e8",
    },
  },
  outline: {
    background: "transparent",
    color: "var(--text-white)",
    border: "1px solid var(--text-white)",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
    },
  },
  text: {
    ...typographyStyles.h4,
    background: "transparent",
    color: "var(--brand-primary)",
    border: "none",
    "&:hover": {
      background: "transparent",
      opacity: 0.8,
    },
  },
};

const StyledButton = styled(MuiButton)<{ btnvariant?: ButtonVariant }>(
  ({ btnvariant = "primary" }) => ({
    fontFamily: "var(--font-family)",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "19px",
    padding: "12px 20px",
    borderRadius: "12px",
    textTransform: "none",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    ...variantStyles[btnvariant],
    "&:disabled": {
      opacity: 0.6,
    },
    // Add gap for text variant with icon
    ...(btnvariant === "text" && {
      gap: "4px",
      padding: "0",
      minWidth: "auto",
    }),
  })
);

export const Button = ({ variant = "primary", children, ...props }: CustomButtonProps) => {
  return (
    <StyledButton {...props} btnvariant={variant}>
      {children}
      {variant === "text" && (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M5.03021 13.3033C4.67873 12.9519 4.67873 12.382 5.03021 12.0305L9.06048 8.00026L5.03021 3.96999C4.67873 3.61852 4.67873 3.04867 5.03021 2.6972C5.38168 2.34573 5.95153 2.34573 6.303 2.6972L10.9697 7.36386C11.3211 7.71534 11.3211 8.28518 10.9697 8.63666L6.303 13.3033C5.95153 13.6548 5.38168 13.6548 5.03021 13.3033Z" fill="currentColor" />
        </svg>
      )}
    </StyledButton>
  );
};
